import { api } from '@/lib/api';
import type { GLReport, MonthEntry, PnLReport } from './types';

export async function fetchPnL(start: string, end: string): Promise<PnLReport> {
  return api.get<PnLReport>('/v4/pnl', { start, end });
}

export async function clearPnLCache(): Promise<{ cleared: number }> {
  return api.delete<{ cleared: number }>('/v4/pnl/cache');
}

export async function fetchGL(
  accountId: string,
  start: string,
  end: string,
): Promise<GLReport> {
  return api.get<GLReport>('/v4/pnl/gl', { accountId, start, end });
}

/**
 * Build a months list client-side (port of tRPC getMonthsList from qbo-webui).
 * Returns ascending order (oldest → newest).
 */
export function buildMonthsList(months: number): MonthEntry[] {
  const today = new Date();
  const results: MonthEntry[] = [];
  for (let i = 0; i < months; i++) {
    const date = new Date(today.getFullYear(), today.getMonth() - i, 1);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const pad = String(month).padStart(2, '0');
    const startDate = `${year}-${pad}-01`;
    const lastDay = new Date(year, month, 0).getDate();
    const endDate = `${year}-${pad}-${String(lastDay).padStart(2, '0')}`;
    const label = date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
    results.push({ month: `${year}-${pad}`, label, startDate, endDate });
  }
  results.sort((a, b) => a.month.localeCompare(b.month));
  return results;
}
